module.exports = (function () {

  const env = process.env
  const UID = env.UID
  const PORT = env.PORT
  const HOST = env.HOST
  const MEMCACHED_SERVERS = (env.MEMCACHED_SERVERS || '127.0.0.1:11211').split(',')
  const MEMCACHED_POOLSIZE = env.MEMCACHED_POOLSIZE
  const MEMCACHED_TIMEOUT = env.MEMCACHED_TIMEOUT
  const MEMCACHED_RETRIES = env.MEMCACHED_RETRIES
  const MEMCACHED_FAILURES = env.MEMCACHED_FAILURES
  const MEMCACHED_NAMESPACE = env.MEMCACHED_NAMESPACE

  // CDN path for serving App bundles
  const CDN_PATH = env.CDN_PATH

  const GZIPPED_REQUESTS = env.GZIPPED_REQUESTS

  // Site API host names. We use different host names
  // for backchannel calls inside the datacenters vs
  // from the public internet
  const SITE_API_FRONTCHANNEL_HOST = env.SITE_API_FRONTCHANNEL_HOST
  const SITE_API_BACKCHANNEL_HOST = env.SITE_API_BACKCHANNEL_HOST
  const V1_API_FRONTCHANNEL_HOST = env.V1_API_FRONTCHANNEL_HOST
  const V1_API_BACKCHANNEL_HOST = env.V1_API_BACKCHANNEL_HOST
  const NOW_API_FRONTCHANNEL_HOST = env.NOW_FRONTCHANNEL_HOST
  const NOW_API_BACKCHANNEL_HOST = env.NOW_BACKCHANNEL_HOST

  const API_TIMEOUT = env.API_TIMEOUT

  const SCORETC_FRONTCHANNEL_HOST = env.SCORETC_FRONTCHANNEL_HOST
  const SCORETC_BACKCHANNEL_HOST = env.SCORETC_BACKCHANNEL_HOST

  // MEMCACHED DEFAULTS
  const MEMCACHED_LIVE_DATA_TTL = env.MEMCACHED_LIVE_DATA_TTL
  const MEMCACHED_DEFAULT_DATA_TTL = env.MEMCACHED_DEFAULT_DATA_TTL

  // In Memory Caching configurations
  const IN_MEM_CACHE_SHELL_TTL = env.IN_MEM_CACHE_SHELL_TTL
  const IN_MEM_CACHE_SHELL_STALE_TTL = env.IN_MEM_CACHE_SHELL_STALE_TTL
  const IN_MEM_CACHE_I18N_TTL = env.IN_MEM_CACHE_I18N_TTL
  const IN_MEM_CACHE_I18N_STALE_TTL = env.IN_MEM_CACHE_I18N_STALE_TTL
  const SERVER_REQUEST_TIMEOUT = env.SERVER_REQUEST_TIMEOUT

  const PRIMER_ACTIVE = env.PRIMER_ACTIVE
  const PRIMER_SUMMARIES = env.PRIMER_SUMMARIES

  return {
    uid : UID || 'reduxion',
    port : parseInt(PORT, 10) || 1377,
    host : HOST || '0.0.0.0',
    //axios request timeout for pageShell, translation (1000ms default)
    serverRequestTimeout: parseInt(SERVER_REQUEST_TIMEOUT, 10) || 2500,
    api: {
      // Specifies the number of milliseconds before the request times out; 5000ms client-side, 1000ms by default
      timeout: parseInt(API_TIMEOUT, 10) || ((process.browser) ? 10000 : 2500),
      useGzip: (GZIPPED_REQUESTS === 'true')
    },
    cacheDuration: {
      // Duration for which every API is cached by default,
      // can be overridden at each API level
      liveData : parseInt(MEMCACHED_LIVE_DATA_TTL, 10) || 5,
      defaultData : parseInt(MEMCACHED_DEFAULT_DATA_TTL, 10) || 60,

      // Duration for which pageShell is cached
      shell : parseInt(IN_MEM_CACHE_SHELL_TTL, 10) || 300,
      shellStale : parseInt(IN_MEM_CACHE_SHELL_STALE_TTL, 10) || 1800,

      // Duration for which translationMap is cached
      translation : parseInt(IN_MEM_CACHE_I18N_TTL, 10) || 300,
      translationStale : parseInt(IN_MEM_CACHE_I18N_STALE_TTL, 10) || 1800
    },
    // ideally, this would get merged into the api
    // key, but Object.assign doesnt' do deep copies.
    // TODO: discuss adding underscore/lo-dash/etc.
    apiHost: {
      sCoreTcClient: SCORETC_FRONTCHANNEL_HOST || 'cdn.espn.com/core',
      sCoreTcServer: SCORETC_BACKCHANNEL_HOST || 'glue-bc.prod.espninfra.starwave.com/core',
      client: SITE_API_FRONTCHANNEL_HOST || 'site.api.espn.com',
      server: SITE_API_BACKCHANNEL_HOST || 'site.api.prod.espninfra.starwave.com',
      client_qa: 'site.api.qa.espn.com',
      server_qa: 'site.api.qa.espninfra.starwave.com',
      client_v1: V1_API_FRONTCHANNEL_HOST || 'api-app.espn.com',
      server_v1: V1_API_BACKCHANNEL_HOST || 'api.prod.espninfra.starwave.com',
      now_client: NOW_API_FRONTCHANNEL_HOST || 'now.core.api.espn.com',
      now_server: NOW_API_BACKCHANNEL_HOST || 'now.core.api.prod.espninfra.starwave.com'
    },
    cache: {
      servers : MEMCACHED_SERVERS,
      poolSize : parseInt(MEMCACHED_POOLSIZE, 10) || 50,
      timeout : parseInt(MEMCACHED_TIMEOUT, 10) || 1000,
      retries : parseInt(MEMCACHED_RETRIES, 10) || 1,
      failures : parseInt(MEMCACHED_FAILURES, 10) || 1,
      namespace : MEMCACHED_NAMESPACE || ''
    },
    cdnPath: CDN_PATH || '',
    cachePrimer: {
      active: ((PRIMER_ACTIVE === undefined) ? true : (PRIMER_ACTIVE === 'true')),
      primeSummaries: ((PRIMER_SUMMARIES === undefined) ? true : (PRIMER_SUMMARIES === 'true'))
    }

  }
}())



// WEBPACK FOOTER //
// ../config/env.config.js